import axios from "axios";

export const ciamSessionRequest = async (params: {
  id_token: string;
}): Promise<void> => {
  const { id_token } = params;
  const { data } = await axios.post("/api/ciam_session", {
    id_token
  },{
    headers: {
        'Content-Type': 'application/json'
    }
});

  return data;
};
